import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=0387714b"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports